<template>
    <div id="app">
        <router-link to="/" class="logo">
            <div class="logo-image">
                <img
                    v-if="checkIfDefaultTheme"
                    src="@images/inconvo-logo-black-without-o.svg"
                    alt="inconvo logo"
                />
                <div class="spinner-image">
                    <Spinner name="branded" color="red" />
                </div>
            </div>
        </router-link>
    </div>
</template>

<script>
import config from '@/config';
import { Themes } from '@/store/enums/themes.enum';
import Spinner from '@/components/ui/Spinner';

export default {
    name: 'AuthCallback',
    components: {
        Spinner,
    },
    computed: {
        checkIfDefaultTheme() {
            return config.theme === Themes.defaultTheme;
        },
    },
    created() {
        setTimeout(() => this.$router.push('/'), 2000);
    },
};
</script>

<style lang="scss" scoped>
.logo {
    position: absolute;
    display: block;
    width: 350px;
    width: 180px;
    height: 28px;

    @include center();

    @include media-query(medium) {
        width: 290px;
        height: 42px;
    }

    .logo-image {
        position: relative;

        .spinner-image {
            display: block;
            position: absolute;
            margin-left: -8px;
            margin-top: 1px;

            @include center();

            @include media-query(medium) {
                margin-top: 0px;
                margin-left: -14px;
            }

            svg {
                font-size: 28px !important;

                @include media-query(medium) {
                    font-size: 46px !important;
                }
            }
        }
    }
}
</style>
